import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {

  intercept(httpRequest: HttpRequest<any>, httpHandler: HttpHandler): Observable<HttpEvent<any>> {
    httpRequest = httpRequest.clone({
      setHeaders: {}
    });

    return httpHandler.handle(httpRequest);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-http-client/auth-http-client.module.ts